module.exports = __webpack_public_path__ + "static/img/fkzt4.cac18c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/fkzt4.png
// module id = 321
// module chunks = 0